import { createSelector } from "reselect";
import { get } from "lodash";
import { skipToken } from "@reduxjs/toolkit/query";
import { GetSignalsRequest } from "@shared/types";
import { sharedLib } from "@shared/services/shared.service";

const selectSignalsDataStore = (args?: GetSignalsRequest) =>
  sharedLib.sharedApi.signals.endpoints.getSignalsData.select(
    args ?? skipToken
  );

const selectSubGroupData = (subGroupID?: number) =>
  createSelector(
    sharedLib.sharedApi.settings.endpoints.getGroupsData.select(),
    ({ data }) => {
      return data?.find((groupData) => groupData.id === subGroupID);
    }
  );

const selectPrecision = (args?: GetSignalsRequest) =>
  createSelector(selectSignalsDataStore(args), (signalsDataStore) =>
    get(signalsDataStore, ["data", "precision"])
  );

export const signalsSelectors = {
  selectPrecision,
  selectSubGroupData,
};
